export default "/staticreactui/static/media/static/media/customer4.965e238c.png";